import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useLayoutEffect, useMemo, useRef, } from 'react';
import MuiListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import { combineClasses, removeClassName, styled, useForkRef, useThemeProps, } from '../../../foundation';
import { ListItemSecondaryActionStyle } from './styles';
import { RcListItemSecondaryActionClasses } from './utils';
var _RcListItemSecondaryAction = forwardRef(function (inProps, ref) {
    var props = useThemeProps({
        props: inProps,
        name: 'RcListItemSecondaryAction',
    });
    var classesProp = props.classes, children = props.children, rest = __rest(props, ["classes", "children"]);
    var innerRef = useRef(null);
    var divRef = useForkRef(innerRef, ref);
    var classes = useMemo(function () { return combineClasses(RcListItemSecondaryActionClasses, classesProp); }, [classesProp]);
    // * need remove not need MuiButton-iconSizeMedium for icon render correct
    useLayoutEffect(function () {
        removeClassName(innerRef, 'MuiListItemSecondaryAction-root');
    });
    return (React.createElement(MuiListItemSecondaryAction, __assign({}, rest, { ref: divRef, classes: classes }), children));
});
var RcListItemSecondaryAction = styled(_RcListItemSecondaryAction)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), ListItemSecondaryActionStyle);
RcListItemSecondaryAction.defaultProps = {};
RcListItemSecondaryAction.displayName = 'RcListItemSecondaryAction';
export { RcListItemSecondaryAction };
var templateObject_1;
